"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const hash_1 = __importDefault(require("@emotion/hash"));
const get_safe_value_1 = __importDefault(require("./get-safe-value"));
let PREFIX = 'ub-';
function getClassNamePrefix() {
    return PREFIX;
}
exports.getClassNamePrefix = getClassNamePrefix;
function setClassNamePrefix(prefix) {
    PREFIX = prefix;
}
exports.setClassNamePrefix = setClassNamePrefix;
/**
 * Generates the class name.
 */
function getClassName(propertyInfo, value) {
    const { className, safeValue = false, // Value never contains unsafe characters. e.g: 10, hidden, border-box
    complexValue = false // Complex values that are best hashed. e.g: background-image
     } = propertyInfo;
    let valueKey;
    // Shortcut the global keywords
    if (value === 'inherit' || value === 'initial' || value === 'unset') {
        valueKey = value;
        /* Always hash values that contain a calc() because the operators get
        stripped which can result in class name collisions
        */
    }
    else if (complexValue || value.includes('calc(')) {
        valueKey = hash_1.default(value);
    }
    else if (safeValue) {
        valueKey = value;
    }
    else {
        valueKey = get_safe_value_1.default(value);
    }
    return `${PREFIX}${className}_${valueKey}`;
}
exports.default = getClassName;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0LWNsYXNzLW5hbWUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvZ2V0LWNsYXNzLW5hbWUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSx5REFBZ0M7QUFDaEMsc0VBQTJDO0FBRTNDLElBQUksTUFBTSxHQUFHLEtBQUssQ0FBQTtBQUVsQixTQUFnQixrQkFBa0I7SUFDaEMsT0FBTyxNQUFNLENBQUE7QUFDZixDQUFDO0FBRkQsZ0RBRUM7QUFFRCxTQUFnQixrQkFBa0IsQ0FBQyxNQUFjO0lBQy9DLE1BQU0sR0FBRyxNQUFNLENBQUE7QUFDakIsQ0FBQztBQUZELGdEQUVDO0FBV0Q7O0dBRUc7QUFDSCxTQUF3QixZQUFZLENBQUMsWUFBMEIsRUFBRSxLQUFhO0lBQzVFLE1BQU0sRUFDSixTQUFTLEVBQ1QsU0FBUyxHQUFHLEtBQUssRUFBRSxzRUFBc0U7SUFDekYsWUFBWSxHQUFHLEtBQUssQ0FBQyw2REFBNkQ7TUFDbkYsR0FBRyxZQUFZLENBQUE7SUFDaEIsSUFBSSxRQUFnQixDQUFBO0lBRXBCLCtCQUErQjtJQUMvQixJQUFJLEtBQUssS0FBSyxTQUFTLElBQUksS0FBSyxLQUFLLFNBQVMsSUFBSSxLQUFLLEtBQUssT0FBTyxFQUFFO1FBQ25FLFFBQVEsR0FBRyxLQUFLLENBQUE7UUFDaEI7O1VBRUU7S0FDSDtTQUFNLElBQUksWUFBWSxJQUFJLEtBQUssQ0FBQyxRQUFRLENBQUMsT0FBTyxDQUFDLEVBQUU7UUFDbEQsUUFBUSxHQUFHLGNBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQTtLQUN2QjtTQUFNLElBQUksU0FBUyxFQUFFO1FBQ3BCLFFBQVEsR0FBRyxLQUFLLENBQUE7S0FDakI7U0FBTTtRQUNMLFFBQVEsR0FBRyx3QkFBWSxDQUFDLEtBQUssQ0FBQyxDQUFBO0tBQy9CO0lBRUQsT0FBTyxHQUFHLE1BQU0sR0FBRyxTQUFTLElBQUksUUFBUSxFQUFFLENBQUE7QUFDNUMsQ0FBQztBQXZCRCwrQkF1QkMifQ==